import { ensureNoUndefinedProperties } from '@/Shared/Helper/EnsureNoUndefinedProperties'
import CustomFieldID from '@/App/CustomField/Entity/CustomFieldID'
import CustomFieldResponseID from '@/App/CustomField/Entity/CustomFieldResponseID'
import {
    CustomFieldTypeEnum,
    type CustomFieldResponseData,
} from '@/Shared/AutoGenerated/Main'

export default class CustomFieldResponse {
    constructor(
        public readonly id: CustomFieldID,
        public readonly snapshotIsRequired: boolean,
        public readonly snapshotType: CustomFieldTypeEnum,
        public readonly content: string | string[] | null,
    ) {
        ensureNoUndefinedProperties(this)
    }

    isEmpty(): boolean {
        if (Array.isArray(this.content)) {
            return this.content.length > 0
        }

        return !this.content
    }

    isNotEmpty(): boolean {
        return this.isEmpty() === false
    }

    // ------------------------
    // Hydration
    // ------------------------

    static hydrateSingle(
        entityData: CustomFieldResponseData,
    ): CustomFieldResponse {
        return new CustomFieldResponse(
            new CustomFieldResponseID(entityData.id),
            entityData.snapshotIsRequired,
            entityData.snapshotType,
            entityData.content,
        )
    }

    static hydrateMultiple(
        entitiesData: CustomFieldResponseData[],
    ): CustomFieldResponse[] {
        return entitiesData.map((entityData) => this.hydrateSingle(entityData))
    }
}
